module.exports = __webpack_public_path__ + "static/locales/id.1LPPiim.json";